import type { RootState } from 'src/redux';

import { selectFlags } from './select-flags';

export const shouldExposeNewVideoDetailsPage = (state: RootState) =>
  !!selectFlags(state)['expose-new-video-details-page'];
